import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FinanceProgram } from '../models/quote.model';

@Injectable({
  providedIn: 'root'
})
export class ProgramService {
  private readonly apiUrl = `${environment.apiUrl}/api/v1/programs`;

  constructor(private http: HttpClient) {}

  getPrograms(): Observable<FinanceProgram[]> {
    return this.http.get<FinanceProgram[]>(this.apiUrl);
  }

  getProgram(id: number): Observable<FinanceProgram> {
    return this.http.get<FinanceProgram>(`${this.apiUrl}/${id}`);
  }

  createProgram(program: Partial<FinanceProgram>): Observable<FinanceProgram> {
    return this.http.post<FinanceProgram>(this.apiUrl, program);
  }
}
